/**
 * Custom menu frontend compatibility for ScandiPWA
 * @copyright Scandiweb, Inc. All rights reserved.
 */

import { Field, Query } from '@tilework/opus';

import { Menu, MenuItem } from '../type/Menu.type';

/** @namespace Scandiweb/ScandipwaMenu/Plugin/ScandipwaMenuQuery/Plugin/getMenuItemFields */
export const getMenuItemFields = (): Array<
Field<'url', string>
| Field<'icon', string>
| Field<'title', string>
| Field<'item_id', string>
| Field<'position', number>
| Field<'url_type', number>
| Field<'parent_id', number>
| Field<'is_active', boolean>
| Field<'item_class', string>
| Field<'category_id', number>
| Field<'cms_page_identifier', string>
> => [
    new Field<'url', string>('url'),
    new Field<'icon', string>('icon'),
    new Field<'title', string>('title'),
    new Field<'item_id', string>('item_id'),
    new Field<'position', number>('position'),
    new Field<'url_type', number>('url_type'),
    new Field<'parent_id', number>('parent_id'),
    new Field<'is_active', boolean>('is_active'),
    new Field<'item_class', string>('item_class'),
    new Field<'category_id', number>('category_id'),
    new Field<'cms_page_identifier', string>('cms_page_identifier'),
];

/** @namespace Scandiweb/ScandipwaMenu/Plugin/ScandipwaMenuQuery/Plugin/getMenuItemsField */
export const getMenuItemsField = (): Field<'items', MenuItem, true> => new Field<
'items',
MenuItem,
true
>('items', true).addFieldList(getMenuItemFields());

/** @namespace Scandiweb/ScandipwaMenu/Plugin/ScandipwaMenuQuery/Plugin/getMenuFields */
export const getMenuFields = (): Array<
Field<'menu_id', string>
| Field<'is_active', boolean>
| Field<'css_class', string>
| Field<'items', MenuItem, true>
> => [
    new Field<'menu_id', string>('menu_id'),
    new Field<'is_active', boolean>('is_active'),
    new Field<'css_class', string>('css_class'),
    getMenuItemsField(),
];

/** @namespace Scandiweb/ScandipwaMenu/Plugin/ScandipwaMenuQuery/Plugin/getCustomMenuQuery */
export const getCustomMenuQuery = ({ identifier }: { identifier: string }): Query<'menu', Menu> => new Query<
'scandiwebMenu',
Menu
>('scandiwebMenu')
    .addArgument('identifier', 'String!', identifier)
    .addFieldList(getMenuFields())
    .setAlias('menu');

export default {
    'Query/Menu/Query': {
        'member-function': {
            getQuery: getCustomMenuQuery,
        },
    },
};
